import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ds-kyd-smartphone-unenroll-all-modal',
  templateUrl: './kyd-smartphone-unenroll-all-modal.component.html',
  styleUrls: ['./kyd-smartphone-unenroll-all-modal.component.scss'],
  standalone: false
})
export class KydSmartphoneUnenrollAllModalComponent {
  @Input() policyState: string;
  @Output() unEnrollAll = new EventEmitter();
  @Output() closeModal = new EventEmitter<string>();
  @Input() headerContentRef = 'kydSmartphonePhh.unenrollHeader';
  @Input() bodyContentRef = 'kydSmartphonePhh.unenrollAll';
  @Input() confirmContentRef = 'kydSmartphonePhh.confirmContent';
  @Input() primaryCTA = "Yes, I'm Sure";
  @Input() secondaryCTA = 'No';
  @Input() operators;
  public modalId = 'unenroll-modal';
}
